/**
 * Sticky Note Colors
 *
 * Pastel color palette for suggestion cards and detail overlays.
 * Deterministic color assignment via character-code hashing.
 */

export const STICKY_NOTE_COLORS = [
  '#FFF9C4', // yellow
  '#FFE0B2', // amber
  '#FFCCBC', // peach
  '#F8BBD0', // pink
  '#E1BEE7', // lavender
  '#C5CAE9', // periwinkle
  '#C8E6C9', // mint
  '#DCEDC8', // sage
] as const;

export function getStickyNoteColor(id: string): string {
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash += id.charCodeAt(i);
  }
  return STICKY_NOTE_COLORS[hash % STICKY_NOTE_COLORS.length];
}
